import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";

import { Button as MuiButton, Typography, Stack } from "@mui/material";
import { spacing } from "@mui/system";

const Button = styled(MuiButton)(spacing);

function Page401 () {
    return (
        <Stack p={3} alignItems="center">
            < Typography component="h1" variant="h1" align="center" gutterBottom >
                401
            </Typography >
            <Typography component="h2" variant="h5" align="center" gutterBottom>
                Permission denied.
            </Typography>
            <Typography component="h2" variant="body1" align="center" gutterBottom>
                You do not have permission.
            </Typography>

            <Button
                component={Link}
                to="/Login"
                variant="contained"
                mt={2}
            >
                Return to website
            </Button>
        </Stack >
    );
}

export default Page401;
